__webpack_require__.p = "/portfolio/hotel-menu/";